import {MobilePhoneTestResult} from "./types";
import axios, {AxiosResponse} from "axios";
import {PhoneNumber} from "antd-phone-input";
import {TFunction} from "i18next";

export const checkNumber: (number: PhoneNumber, t: TFunction) => Promise<MobilePhoneTestResult> = (number, t) => {
    if (!number) {
        return Promise.reject(t('phone.number.invalid'))
    }
    const mobile = `${number.countryCode}${number.areaCode}${number.phoneNumber}`;
    return axios.get<object, AxiosResponse<MobilePhoneTestResult>>(`https://easysms.gr/api/mobile/check?mobile=${mobile}&type=json`)
        .then(r => r.data);
}

